/**
 * contactform.js
 * Manages the Feedback Form
 */
jQuery(function($) {
    $('#btShowFeedback').on('click', function(){
        if (! $('#success-msg').hasClass("hidden")) $('#success-msg').addClass("hidden");
        if ($('#feedback-form-container').hasClass("hidden")) $('#feedback-form-container').removeClass("hidden");
        $(this).attr('href', "#");
    });

    $(document).on('change', '#contactform-phone,#contactform-email', function () {
        var str = $(this).val();
        /*
        if (! str.length) {
            str = $('#contactform-phone').val().length ?
                $('#contactform-phone').val() : $('#contactform-email').val();
        }
        */
        $('#contactform-dummy').val(str);
    });

    $(document).on('keypress', '#contactform-phone,#contactform-email', function () {
        var div = $('#contactform-dummy').parent();
        div.removeClass("has-error");
    });

    $(document).on('beforeSubmit', '#contact-form', function () {
        var form = $(this);
        var btn = $('#btContact');
        var origHtml = btn.html();
        btn.prop('disabled', true).html('<span class="glyphicon glyphicon-refresh contact-spin"></span> Надсилається...');

        var restoreBtn = function () {
            btn.prop('disabled', false).html(origHtml);
        };

        var siteKey = $('#feedback-form-container').data('recaptcha-key');

        grecaptcha.ready(function () {
            grecaptcha.execute(siteKey, {action: 'contact'}).then(function (token) {
                form.find('input[name="ContactForm[recaptchaToken]"]').val(token);
                $.ajax({
                    url: form.attr('action'),
                    type: 'post',
                    dataType: 'json',
                    data: form.serialize(),
                    success: function (response) {
                        if (response.success) {
                            if (! $('#feedback-form-container').hasClass("hidden")) $('#feedback-form-container').addClass("hidden");
                            if ($('#success-msg').hasClass("hidden")) $('#success-msg').removeClass("hidden");
                        } else {
                            restoreBtn();
                        }
                    },
                    error: function () {
                        restoreBtn();
                        alert('Помилка!');
                    }
                });
            });
        });
        return false;
    });
});

